module.exports = __webpack_public_path__ + "pc/img/Comp 1_00425 1.46870907.webp";